module.exports = __webpack_public_path__ + "img/M007_04_jrb-03.a651107f.jpg";